export enum LoaderSpinnerTypes {
  None = 'none',
  FullPage = 'fullPage',
  AgGrid = 'agGrid'
}
